export enum ToastResponse {
    Ok,
    Yes,
    Cancel,
    No,
    TimeOut
}